module.exports = __webpack_public_path__ + "media/homepage/header-collage-7b09f801.png";